module.exports = __webpack_public_path__ + "static/img/Harvey-Langford.5ca8929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Harvey-Langford.jpg
// module id = c3fW
// module chunks = 0